import React from "react";
import { SmartTooltip, TableAdv, TagAdv } from "../../../../../../components";
import { useIncentiveRoles } from "../IncentiveModuleLayout";
import { dateFormator, mapTableRows } from "../../../../../../utils";

const actionColorMap = {
  Paid: "success",
  Unpaid: "danger",
};

const MasterSheet = () => {
  const { availableRoles, moduleName } = useIncentiveRoles();
  const rows = [
    {
      id: 1,
      consultantName: "Amit Verma",
      consultantJobTitle: "Bench Consultant (Java)",
      client: "Internal",
      totalSalary: 280,
      percentage: 10,
      commission: 0,
      startDate: "2026-02-15",
      warrantyPeriod: "0",
      ra: "Internal HR",
      bdm: "N/A",
      recruiter: "Sarah",
      dl: "Ethan",
      dm: "Mohsin",
      action: "Paid",
    },
    {
      id: 2,
      consultantName: "Priya Das",
      consultantJobTitle: "Bench Consultant (React)",
      client: "Internal",
      totalSalary: 300,
      percentage: 10,
      commission: 0,
      startDate: "2026-03-01",
      warrantyPeriod: "0",
      ra: "Internal HR",
      bdm: "N/A",
      recruiter: "Sarah",
      dl: "Chris",
      dm: "Rohan",
      action: "Unpaid",
    },
    {
      id: 3,
      consultantName: "Rohit Sharma",
      consultantJobTitle: "Bench Consultant (Python)",
      client: "Internal",
      totalSalary: 310,
      percentage: 10,
      commission: 0,
      startDate: "2026-01-20",
      warrantyPeriod: "0",
      ra: "Internal HR",
      bdm: "N/A",
      recruiter: "David",
      dl: "Ethan",
      dm: "Mohsin",
      action: "Paid",
    },
    {
      id: 4,
      consultantName: "Sneha Gupta",
      consultantJobTitle: "Bench Consultant (.NET)",
      client: "Internal",
      totalSalary: 290,
      percentage: 10,
      commission: 0,
      startDate: "2026-02-10",
      warrantyPeriod: "0",
      ra: "Internal HR",
      bdm: "N/A",
      recruiter: "Sarah",
      dl: "Ethan",
      dm: "Mohsin",
      action: "Paid",
    },
    {
      id: 5,
      consultantName: "Vikram Singh",
      consultantJobTitle: "Bench Consultant (DevOps)",
      client: "Internal",
      totalSalary: 350,
      percentage: 10,
      commission: 0,
      startDate: "2026-03-05",
      warrantyPeriod: "0",
      ra: "Internal HR",
      bdm: "N/A",
      recruiter: "David",
      dl: "Chris",
      dm: "Rohan",
      action: "Unpaid",
    },
    {
      id: 6,
      consultantName: "Ananya Roy",
      consultantJobTitle: "Bench Consultant (QA)",
      client: "Internal",
      totalSalary: 250,
      percentage: 10,
      commission: 0,
      startDate: "2026-01-15",
      warrantyPeriod: "0",
      ra: "Internal HR",
      bdm: "N/A",
      recruiter: "Sarah",
      dl: "Ethan",
      dm: "Mohsin",
      action: "Paid",
    },
    {
      id: 7,
      consultantName: "Karan Johar",
      consultantJobTitle: "Bench Consultant (Data Engineer)",
      client: "Internal",
      totalSalary: 400,
      percentage: 10,
      commission: 0,
      startDate: "2026-02-28",
      warrantyPeriod: "0",
      ra: "Internal HR",
      bdm: "N/A",
      recruiter: "David",
      dl: "Chris",
      dm: "Rohan",
      action: "Unpaid",
    },
    {
      id: 8,
      consultantName: "Meera Iyer",
      consultantJobTitle: "Bench Consultant (UI/UX)",
      client: "Internal",
      totalSalary: 280,
      percentage: 10,
      commission: 0,
      startDate: "2026-03-10",
      warrantyPeriod: "0",
      ra: "Internal HR",
      bdm: "N/A",
      recruiter: "Sarah",
      dl: "Ethan",
      dm: "Mohsin",
      action: "Paid",
    },
    {
      id: 9,
      consultantName: "Arjun Rampal",
      consultantJobTitle: "Bench Consultant (Salesforce)",
      client: "Internal",
      totalSalary: 330,
      percentage: 10,
      commission: 0,
      startDate: "2026-01-25",
      warrantyPeriod: "0",
      ra: "Internal HR",
      bdm: "N/A",
      recruiter: "David",
      dl: "Chris",
      dm: "Rohan",
      action: "Unpaid",
    },
    {
      id: 10,
      consultantName: "Nisha Agarwal",
      consultantJobTitle: "Bench Consultant (SAP)",
      client: "Internal",
      totalSalary: 360,
      percentage: 10,
      commission: 0,
      startDate: "2026-02-05",
      warrantyPeriod: "0",
      ra: "Internal HR",
      bdm: "N/A",
      recruiter: "Sarah",
      dl: "Ethan",
      dm: "Mohsin",
      action: "Paid",
    },
  ];
  const columns = [
    {
      key: "consultantName",
      label: "Consultant Name",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.consultantName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.consultantName}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "consultantJobTitle",
      label: "Consultant Job Title",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.consultantJobTitle}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.consultantJobTitle}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "client",
      label: "Client",
      width: "min-w-[150px]! max-w-[200px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.client}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.client}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "totalSalary",
      label: "Total Salary",
      render: (row) => `$${row.totalSalary}`,
    },
    {
      key: "percentage",
      label: "Percentage",
      render: (row) => `${row.percentage}%`,
    },
    {
      key: "commission",
      label: "Commission",
      render: (row) => `$${row.commission}`,
    },
    {
      key: "startDate",
      label: "Start Date",
      render: (row) => dateFormator(row.startDate),
    },
    {
      key: "warrantyPeriod",
      label: "Warranty Period",
      render: (row) => `${row.warrantyPeriod} Days`,
    },
    {
      key: "ra",
      label: "RA",
      width: "min-w-[150px]! max-w-[200px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.ra}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.ra}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "bdm",
      label: "BDM",
      width: "min-w-[150px]! max-w-[200px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.bdm}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.bdm}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "recruiter",
      label: "Recruiter",
      width: "min-w-[150px]! max-w-[200px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.recruiter}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.recruiter}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "dl",
      label: "DL",
      width: "min-w-[150px]! max-w-[200px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.dl}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.dl}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "dm",
      label: "DM",
      width: "min-w-[150px]! max-w-[200px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.dm}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.dm}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "action",
      label: "Action",
      width: "w-[100px]",
      render: (row) => (
        <div className="flex items-center">
          <TagAdv
            title={row.action}
            size="sm"
            color={actionColorMap[row.action]}
            colorDepth={600}
            className="w-[100px]! text-center"
          />
        </div>
      ),
    },
  ];

  const mappedRows = mapTableRows(rows, columns);

  const getResolvedRoleName = (item) => {
    // Bench module allows [1, 4]
    const allowedModules = [1, 4];
    const roleId = item.roleId || item.roleType;
    if (!roleId || !availableRoles?.length) return item.roleName || "Unknown";
    
    // First try to resolve by UIID or Type
    const role = availableRoles.find(r => String(r.uiid) === String(roleId) || String(r.type) === String(roleId));
    
    if (role && allowedModules.includes(role.module)) {
      return role.name;
    }
    return "Unknown";
  };

  return (
    <div className="h-full flex-1 w-full flex flex-col overflow-hidden">
      <TableAdv
        title="Master Sheet"
        columns={columns}
        rows={mappedRows}
        toolbarRight={{ search: true }}
      />
    </div>
  );
};

export default MasterSheet;
